import React, { useContext } from "react";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EventContext } from "Components";

export const MusicVideo = ({ setModalVisible }) => {
  const { event } = useContext(EventContext);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const storageDirectory = event.storageDirectory;

  const {
    background: musicVideoBackground,
    heading: musicVideoHeading,
    video: musicVideoLink,
  } = event.callToActions.musicVideo;

  const musicVideoBg = `${api}/o/${storageDirectory}%2F${musicVideoBackground}?alt=media`;

  return (
    <MusicVideoWrapper background={musicVideoBg}>
      <MusicVideoContent>
        <MusicVideoCTA>
          <PlayIcon
            onClick={() => setModalVisible(true, musicVideoLink, "Music Video")}
          >
            <FontAwesomeIcon icon={["far", "play-circle"]} />
          </PlayIcon>
          <h4>{ReactHtmlParser(musicVideoHeading)}</h4>
        </MusicVideoCTA>
      </MusicVideoContent>
    </MusicVideoWrapper>
  );
};

const MusicVideoWrapper = styled.div`
  background-image: url(${(props) => props.background});
  background-size: cover;
  background-position: center;
  padding-top: 56.25%;
  position: relative;
`;

const MusicVideoContent = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  padding: 25px 15px;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 25px;
  }
`;

const MusicVideoCTA = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: #ffffff;

  h4 {
    text-transform: uppercase;
    font-size: clamp(24px, 6vw, 52px);
    margin: 0;
    line-height: 1.25;

    span {
      display: block;
      font-size: clamp(16px, 4.15vw, 36px);
      margin-left: clamp(9px, 2.5vw, 20px);
    }
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    h4 {
      font-size: 37px;

      span {
        font-size: 24px;
        margin-left: 15px;
      }
    }
  }
`;

const PlayIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: clamp(46px, 11vw, 88px);
  margin-right: 15px;

  path {
    fill: #ffffff;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    font-size: 64px;
  }
`;
